import { authInstance } from './axios'
let url = process.env.REACT_APP_API_URL

export const paymentsService = {
  createMembershipPayment: async (data) => {
    const response = await authInstance
      .post(`${url}/payments/createMembershipPayment`, data)
      .then(async (response) => {
        return response
      })
      .catch(function (error) {
        error.data = []
        return error
      })
    return response
  },

  editPayment: async (data) => {
    const response = await authInstance
      .put(`${url}/payments/update`, data)
      .then(async (response) => {
        return response
      })
      .catch(function (error) {
        error.data = []
        return error
      })
    return response
  },

  createPendingPayment: async (data) => {
    const response = await authInstance
      .post(`${url}/payments/createMembershipPendingPayment`, data)
      .then(async (response) => {
        return response
      })
      .catch(function (error) {
        error.data = []
        return error
      })
    return response
  },

  // createMembershipPayment: async (data) => {
  //   const myInit = {
  //     headers: {
  //       'x-api-key': process.env.REACT_APP_X_API_KEY,
  //       Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
  //     },
  //     method: 'POST',
  //     body: data,
  //   };

  //   const response = await fetch(
  //     `${url}/payments/createMembershipPayment`,
  //     myInit
  //   )
  //     .then(async (response) => {
  //       return fixResponseJSON(response);
  //     })
  //     .catch(function (error) {
  //       ;
  //       error.data = [];
  //       return error;
  //     });
  //   return response;
  // },
}
